import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App'
import './ui/tokens/estilos-base.css'

// Aplica la apariencia guardada antes del primer pintado (sin script en línea: la CSP lo prohíbe).
try { document.documentElement.dataset.apariencia = localStorage.getItem('chilesst.apariencia') === 'black' ? 'black' : 'claro' } catch { document.documentElement.dataset.apariencia = 'claro' }

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta el contenedor #raiz')

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
